<template>
    <div
        v-if="reviewStatus === 'REVIEW_AWAITING'"
        class="video-review"
    >
        <p class="video-review__label">Watch the full video to review</p>

        <BaseButton
            class="base-button--wide"
            @click="handleStartReview"
        >
            Start peer review
        </BaseButton>
    </div>
    <div
        v-else-if="reviewStatus === 'REVIEW_SUBMITTED'"
        class="video-review"
    >
        <p class="video-review__label">Thanks for you review!</p>
    </div>
</template>
<script setup>
import { useModalStore, MODAL_LOGIN, MODAL_REVIEW } from '~/store/modal';
import { useAuthStore } from '~/store/auth';
const { push } = useTagmanager();

const props = defineProps({
    video: {
        type: Object,
        default: null,
        required: false
    },
    reviewStatus: {
        type: String,
        default: null,
        required: false
    }
});

const modalStore = useModalStore();
const authStore = useAuthStore();

function handleStartReview() {
    if (!authStore.loggedIn) {
        modalStore.toggleModal(MODAL_LOGIN);
        return;
    }

    if (!props.video) {
        return;
    }

    push({ event: 'peer_review_form_opened' });
    modalStore.toggleModal(MODAL_REVIEW);
}

onMounted(() => {
    push({
        event: 'peer_review_page_view'
    });
});
</script>

<style lang="less">
.video-review {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    overflow: auto;

    @media @q-xl-max {
        margin-top: var(--spacing-md);
    }

    .dn-button.base-button {
        @media @q-md-min {
            .typography-label-xs();
            padding: .375rem .625rem;

            .dn-icon {
                font-size: 1rem;
            }
        }
    }

    scrollbar-width: none;

    .video-review__label {
        .typography-h6();
    }

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
